export const isAuthenticated = (state) => {
  // console.log(state);
  const userDetails = JSON.parse(localStorage.getItem("userDetails") || "{}");

  const token =
    state.auth?.auth?.data?.auth_token || userDetails?.data?.auth_token;

  return Boolean(token);
};
